module.exports = __webpack_public_path__ + "static/img/icon_app_download_title.cf7b088.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_app_download_title.png
// module id = IeJo
// module chunks = 1